<div class="risk-analysis" *ngIf="riskAnalysis">
    <!-- Summary Section -->
    <div class="risk-summary" [ngClass]="getRiskLevelClass()">
        <div class="risk-summary-header">
            <h3>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.OVERALL_RISK' | translate }}</h3>
            <span class="risk-level-badge">{{ riskAnalysis.overall_result.overall_risk_level }}</span>
        </div>
        <p class="risk-summary-text">{{ riskAnalysis.overall_result.summary }}</p>
    </div>

    <!-- Risk Sections in Three Columns -->
    <div class="risk-columns">
        <!-- High Risk -->
        <div class="risk-column high-risk">
            <div class="risk-column-header">
                <span class="material-symbols-rounded">error</span>
                <h4>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.HIGH_RISK' | translate }}</h4>
                <span class="risk-count">{{ riskAnalysis.risk_sections.high_risk.length }}</span>
            </div>
            <div class="risk-items">
                <div class="risk-item" *ngFor="let risk of riskAnalysis.risk_sections.high_risk">
                    <div class="risk-item-header">
                        <span class="risk-id">{{ risk.risk_id }}</span>
                        <h5>{{ risk.title }}</h5>
                    </div>
                    <p class="risk-description">{{ risk.description }}</p>
                    <div class="risk-impact">
                        <strong>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.IMPACT' | translate }}:</strong>
                        {{ risk.impact }}
                    </div>
                    <div class="risk-action">
                        <strong>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.RECOMMENDED_ACTION' | translate }}:</strong>
                        {{ risk.recommended_action }}
                    </div>
                </div>
                <div class="risk-empty" *ngIf="riskAnalysis.risk_sections.high_risk.length === 0">
                    {{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.NO_RISKS' | translate }}
                </div>
            </div>
        </div>

        <!-- Medium Risk -->
        <div class="risk-column medium-risk">
            <div class="risk-column-header">
                <span class="material-symbols-rounded">warning</span>
                <h4>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.MEDIUM_RISK' | translate }}</h4>
                <span class="risk-count">{{ riskAnalysis.risk_sections.medium_risk.length }}</span>
            </div>
            <div class="risk-items">
                <div class="risk-item" *ngFor="let risk of riskAnalysis.risk_sections.medium_risk">
                    <div class="risk-item-header">
                        <span class="risk-id">{{ risk.risk_id }}</span>
                        <h5>{{ risk.title }}</h5>
                    </div>
                    <p class="risk-description">{{ risk.description }}</p>
                    <div class="risk-impact">
                        <strong>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.IMPACT' | translate }}:</strong>
                        {{ risk.impact }}
                    </div>
                    <div class="risk-action">
                        <strong>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.RECOMMENDED_ACTION' | translate }}:</strong>
                        {{ risk.recommended_action }}
                    </div>
                </div>
                <div class="risk-empty" *ngIf="riskAnalysis.risk_sections.medium_risk.length === 0">
                    {{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.NO_RISKS' | translate }}
                </div>
            </div>
        </div>

        <!-- Low Risk -->
        <div class="risk-column low-risk">
            <div class="risk-column-header">
                <span class="material-symbols-rounded">info</span>
                <h4>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.LOW_RISK' | translate }}</h4>
                <span class="risk-count">{{ riskAnalysis.risk_sections.low_risk.length }}</span>
            </div>
            <div class="risk-items">
                <div class="risk-item" *ngFor="let risk of riskAnalysis.risk_sections.low_risk">
                    <div class="risk-item-header">
                        <span class="risk-id">{{ risk.risk_id }}</span>
                        <h5>{{ risk.title }}</h5>
                    </div>
                    <p class="risk-description">{{ risk.description }}</p>
                    <div class="risk-impact">
                        <strong>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.IMPACT' | translate }}:</strong>
                        {{ risk.impact }}
                    </div>
                    <div class="risk-action">
                        <strong>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.RECOMMENDED_ACTION' | translate }}:</strong>
                        {{ risk.recommended_action }}
                    </div>
                </div>
                <div class="risk-empty" *ngIf="riskAnalysis.risk_sections.low_risk.length === 0">
                    {{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.NO_RISKS' | translate }}
                </div>
            </div>
        </div>
    </div>

    <!-- Action Summary -->
    <div class="action-summary">
        <h3>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.ACTION_SUMMARY' | translate }}</h3>
        <div class="action-columns">
            <div class="action-column must-do" *ngIf="riskAnalysis.action_summary.must_do.length > 0">
                <h4>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.MUST_DO' | translate }}</h4>
                <ul>
                    <li *ngFor="let action of riskAnalysis.action_summary.must_do">{{ action }}</li>
                </ul>
            </div>
            <div class="action-column should-do" *ngIf="riskAnalysis.action_summary.should_do.length > 0">
                <h4>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.SHOULD_DO' | translate }}</h4>
                <ul>
                    <li *ngFor="let action of riskAnalysis.action_summary.should_do">{{ action }}</li>
                </ul>
            </div>
            <div class="action-column optional" *ngIf="riskAnalysis.action_summary.optional.length > 0">
                <h4>{{ 'FEATURES.AGREEMENTS.RISK_ANALYSIS.OPTIONAL' | translate }}</h4>
                <ul>
                    <li *ngFor="let action of riskAnalysis.action_summary.optional">{{ action }}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
